import type { ChartPalette } from '../chart.js';

// Six named colour palettes shared by builtins and the builder. The names
// describe the visual identity (hue) rather than any specific track so a
// chart can adopt whichever palette best matches its mood without
// implying ownership.

export const PALETTE_MAGENTA: ChartPalette = {
  bg: '#0a0e27',
  bgAccent: '#1a1f4d',
  player: '#ff2bd6',
  pad: '#16e0ff',
  padPerfect: '#3bff9d',
  hazard: '#ff3b5c',
  goal: '#b6ff3b',
  ui: '#e8ecff',
};

export const PALETTE_CYAN: ChartPalette = {
  bg: '#040a14',
  bgAccent: '#0e2336',
  player: '#3bff9d',
  pad: '#16e0ff',
  padPerfect: '#ff2bd6',
  hazard: '#ff3b5c',
  goal: '#ffae3b',
  ui: '#e8ecff',
};

export const PALETTE_VIOLET: ChartPalette = {
  bg: '#100417',
  bgAccent: '#2a0e3a',
  player: '#ffae3b',
  pad: '#ff2bd6',
  padPerfect: '#16e0ff',
  hazard: '#ff3b5c',
  goal: '#3bff9d',
  ui: '#e8ecff',
};

export const PALETTE_AMBER: ChartPalette = {
  bg: '#170d04',
  bgAccent: '#3a1d0a',
  player: '#ff2bd6',
  pad: '#ffae3b',
  padPerfect: '#3bff9d',
  hazard: '#ff3b5c',
  goal: '#16e0ff',
  ui: '#e8ecff',
};

export const PALETTE_CRIMSON: ChartPalette = {
  bg: '#1a0410',
  bgAccent: '#3a0a25',
  player: '#ffae3b',
  pad: '#ff2bd6',
  padPerfect: '#16e0ff',
  hazard: '#ff3b5c',
  goal: '#3bff9d',
  ui: '#e8ecff',
};

export const PALETTE_VOID: ChartPalette = {
  bg: '#000000',
  bgAccent: '#1a0a3a',
  player: '#ff2bd6',
  pad: '#16e0ff',
  padPerfect: '#b6ff3b',
  hazard: '#ff3b5c',
  goal: '#ffae3b',
  ui: '#e8ecff',
};

export const PALETTE_AURORA: ChartPalette = {
  bg: '#020a1a',
  bgAccent: '#0a2444',
  player: '#a1f0ff',
  pad: '#7b6dff',
  padPerfect: '#ff80c8',
  hazard: '#ff5c5c',
  goal: '#3bff9d',
  ui: '#e8ecff',
};

export const PALETTE_FOREST: ChartPalette = {
  bg: '#06150a',
  bgAccent: '#0e2e1a',
  player: '#ffa53b',
  pad: '#7bffae',
  padPerfect: '#ffe23b',
  hazard: '#ff5c3b',
  goal: '#16e0ff',
  ui: '#e8ecff',
};

export const PALETTE_PRISM: ChartPalette = {
  bg: '#0a0a1f',
  bgAccent: '#1a1a3f',
  player: '#ffffff',
  pad: '#16e0ff',
  padPerfect: '#ff2bd6',
  hazard: '#ff3b5c',
  goal: '#ffe23b',
  ui: '#e8ecff',
};

export const PALETTE_GLACIER: ChartPalette = {
  bg: '#040a18',
  bgAccent: '#1a3a5a',
  player: '#7bd6ff',
  pad: '#e8f0ff',
  padPerfect: '#3bff9d',
  hazard: '#ff5c5c',
  goal: '#ffae3b',
  ui: '#e8ecff',
};

export const PALETTE_INFERNO: ChartPalette = {
  bg: '#1a0500',
  bgAccent: '#3a1300',
  player: '#ffe23b',
  pad: '#ff8a3b',
  padPerfect: '#ff2bd6',
  hazard: '#ff3b5c',
  goal: '#ffffff',
  ui: '#ffeacc',
};

export const PALETTE_TOXIC: ChartPalette = {
  bg: '#040a04',
  bgAccent: '#0a3a1a',
  player: '#b6ff3b',
  pad: '#ff2bd6',
  padPerfect: '#16e0ff',
  hazard: '#ff3b5c',
  goal: '#ffae3b',
  ui: '#ccffcc',
};
